export const getPriorityColor = (level) => {
  const colors = {
    high: 'border-red-500 bg-red-50',
    medium: 'border-yellow-500 bg-yellow-50', 
    low: 'border-green-500 bg-green-50'
  };
  return colors[level] || 'border-gray-500 bg-gray-50';
};

export const sortTasksByDate = (tasks, ascending = false) => {
  return [...tasks].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return ascending ? dateA - dateB : dateB - dateA;
  });
};

export const getTasksByPriority = (tasks) => {
  return {
    high: tasks.filter(task => task.priorityLevel === 'high'),
    medium: tasks.filter(task => task.priorityLevel === 'medium'),
    low: tasks.filter(task => task.priorityLevel === 'low')
  };
};